import cx from 'classnames';
import {
    PHONE_VERIFICATION_ANSWER,
    PHONE_VERIFICATION_ANSWER_FORCED,
    PHONE_VERIFICATION_IT_CAN_TAKE_SOME_TIME,
    PHONE_VERIFICATION_QUESTION,
    PHONE_VERIFICATION_WE_WILL_CALL_YOU,
} from 'mk/autogenerated/translations/PhoneVerification.3de28637866b47902407452d49995c98'
import { analyticsStoreEvent } from 'mk2/actions';
import {
    phoneVerificationGoTo,
    phoneVerificationRequestCall,
    phoneVerificationRequestToken,
    phoneVerificationVerifyToken,
} from 'mk2/containers/PhoneVerification/PhoneVerification.actions';
import { Mode } from 'mk2/containers/PhoneVerification/PhoneVerification.constants';
import SendSmsTokenStep from 'mk2/containers/PhoneVerification/SendSmsTokenStep';
import VerifySmsTokenStep from 'mk2/containers/PhoneVerification/VerifySmsTokenStep';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import {
    AppState,
    getPhoneVerificationLimitReached,
    getPhoneVerificationPhoneNumber,
    getPhoneVerificationPrefix,
    getPhoneVerificationSending,
    getPhoneVerificationStep,
} from 'mk2/reducers';
import React from 'react';
import { connect } from 'react-redux';
import styles from './PhoneVerification.mscss';

interface OwnProps {
    className?: string;
    mode: Mode;
}

interface StateProps {
    step: number;
    prefix: string;
    phoneNumber: string;
    limitReached: boolean;
    sending: boolean;
}

interface DispatchProps {
    onSendSmsToken(prefix: string, phoneNumber: string, mode: Mode);
    onVerifySmsToken(token: string, mode: Mode, fullPhoneNumber: string);
    onStoreEvent(name: string, props: any);
    onCallMe(prefix: string, phoneNumber: string, mode: Mode);
    onGoTo(step: number);
}

type Props = OwnProps & StateProps & DispatchProps;

class PhoneVerification extends React.Component<Props> {

    public render() {
        const {
            className, mode, step, phoneNumber, prefix, limitReached, sending,
            onSendSmsToken, onVerifySmsToken,
        } = this.props;

        return (
            <div className={cx(styles.PhoneVerification, className)}>

                {step === 1 && (
                    <SendSmsTokenStep
                        mode={mode}
                        canSkipToTokenVerification={!!phoneNumber}
                        onSendSmsToken={onSendSmsToken}
                        onStoreEvent={this.onStoreEventStep1}
                        onSkip={this.onGoToSecond}
                        initialValues={{
                            prefix,
                            phoneNumber,
                        }}
                    />
                )}

                {step === 2 && (
                    <VerifySmsTokenStep
                        mode={mode}
                        prefix={prefix}
                        phoneNumber={phoneNumber}
                        limitReached={limitReached}
                        sending={sending}
                        onVerifySmsToken={onVerifySmsToken}
                        onResendSmsToken={this.handleOnSendSMSToken}
                        onCallMe={this.onCallMe}
                        onChangeNumber={this.onGoToFirst}
                        onStoreEvent={this.onStoreEventStep2}
                    />
                )}

                {step === 3 && (
                    <div className={styles.PhoneVerification__weWillCall}>
                        <div className={styles.PhoneVerification__weWillCall__title}>{PHONE_VERIFICATION_WE_WILL_CALL_YOU}</div>
                        <div className={styles.PhoneVerification__weWillCall__content}>{PHONE_VERIFICATION_IT_CAN_TAKE_SOME_TIME}</div>
                    </div>
                )}

                {mode === 'newuser' && (
                    <div className={styles.PhoneVerification__explanation}>
                        <h3 className={styles.PhoneVerification__explanation__title}>
                            {PHONE_VERIFICATION_QUESTION}
                        </h3>
                        <p className={styles.PhoneVerification__explanation__content}>
                            {PHONE_VERIFICATION_ANSWER}
                        </p>
                    </div>
                )}

                {mode === 'forced' && (
                    <div className={styles.PhoneVerification__explanation}>
                        <h3 className={styles.PhoneVerification__explanation__title}>
                            {PHONE_VERIFICATION_QUESTION}
                        </h3>
                        <p className={styles.PhoneVerification__explanation__content}>
                            {PHONE_VERIFICATION_ANSWER_FORCED}
                        </p>
                    </div>
                )}

            </div>
        );
    }

    private onStoreEventStep1 = () => {
        const { onStoreEvent, mode } = this.props;
        onStoreEvent('phone_verification_step_1', { mode });
    };

    private onStoreEventStep2 = () => {
        const { onStoreEvent, mode } = this.props;
        onStoreEvent('phone_verification_step_2', { mode });
    };

    private onGoToFirst = () => this.props.onGoTo(1);
    private onGoToSecond = () => this.props.onGoTo(2);

    private handleOnSendSMSToken = () => {
        const { onSendSmsToken, prefix, phoneNumber, mode } = this.props;
        onSendSmsToken(prefix, phoneNumber, mode);
    };

    private onCallMe = () => {
        const { onCallMe, prefix, phoneNumber, mode } = this.props;
        onCallMe(prefix, phoneNumber, mode);
    };
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        limitReached: getPhoneVerificationLimitReached(state),
        step: getPhoneVerificationStep(state),
        prefix: getPhoneVerificationPrefix(state),
        phoneNumber: getPhoneVerificationPhoneNumber(state),
        sending: getPhoneVerificationSending(state),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onStoreEvent: analyticsStoreEvent,
    onSendSmsToken: phoneVerificationRequestToken,
    onVerifySmsToken: phoneVerificationVerifyToken,
    onCallMe: phoneVerificationRequestCall,
    onGoTo: phoneVerificationGoTo,
};

export default connect(mapStateToProps, mapDispatchToProps)(PhoneVerification);
